export default __webpack_public_path__ + "static/media/parmigiana.feace3cb.jpg";